import React from "react";
import PodcastTop from "../../../components/PodcastTop";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoChevronForwardOutline } from "react-icons/io5";
import translate from "../../../translation";

export default function PodcastsTop({ podcasts }) {
	const navigate = useNavigate();
	const onClick = (e) => {
		navigate(`/podcasts/`);
	};
	return podcasts.map((podcast) =>
		podcast.name === translate("Podcasts les + écoutés") ? (
			<Container className="carousel-container" key={podcast?.name?.toString()}>
				<h2 onClick={onClick} className="sectionTitlePlusEcoutesHome mt-md-5">
					{podcast.name} <IoChevronForwardOutline />
				</h2>

				<div className="carousel-wrapper">
					<PodcastTop podcasts={podcast.series} />
				</div>
			</Container>
		) : null,
	);
}
